import React, { FC, ReactNode, useId } from 'react';
import { ModalDialog } from 'components/ModalDialog/ModalDialog';

import { withNoScroll } from 'hooks/withNoScroll/withNoScroll';
import {
    AlertContent,
    AlertDialogInnerWrapper,
    AlertDialogWrapper,
    DialogBodyText,
    DialogButton,
    DialogButtonContainer,
    DialogTitle,
    ErrorMessage,
    HintText,
    SubtitleText,
} from './AlertDialog.css';

export type AlertPropTypes = {
    title: string;
    bodyText?: ReactNode;
    hintText?: string;
    subTitle: string;
    buttons?: Array<{
        text: string;
        progress?: number;
        onClick: () => void;
    }>;
    errorMessage?: number;
    transparent?: boolean;
};

const Dialog: FC<AlertPropTypes> = ({ title, bodyText, hintText, buttons, subTitle, errorMessage, transparent }) => {
    const titleId = useId();
    const descriptionId = useId();

    const dialogButtons: ReactNode[] = buttons
        ? buttons.map((button, index) => (
              <DialogButton
                  data-test-id={'guest-message-continue-as-a-guest'}
                  key={`dialog-button-${index}`}
                  onClick={button.onClick}
                  isPrimary={index === buttons.length - 1}
                  label={button.text}
                  link={null}
                  data-event-name={'click'}
                  data-track-id={'button_dialog'}
                  data-button-title={button.text}
                  progress={button.progress}
              />
          ))
        : null;

    if (!title && !bodyText && !buttons.length) {
        return null;
    }

    return (
        <ModalDialog
            as={AlertDialogWrapper}
            role="alertdialog"
            closeOnEscape={false}
            transparent={transparent}
            aria-labelledby={titleId}
            aria-describedby={descriptionId}
        >
            <AlertDialogInnerWrapper>
                <AlertContent>
                    <DialogTitle id={titleId} data-test-id={'guest-error-message'}>
                        {title}
                    </DialogTitle>
                    <div id={descriptionId}>
                        {subTitle && <SubtitleText>{subTitle}</SubtitleText>}
                        {bodyText && <DialogBodyText>{bodyText}</DialogBodyText>}
                        {hintText && <HintText>{hintText}</HintText>}
                    </div>
                    {dialogButtons?.length > 0 && <DialogButtonContainer>{dialogButtons}</DialogButtonContainer>}
                </AlertContent>
                <ErrorMessage>{errorMessage}</ErrorMessage>
            </AlertDialogInnerWrapper>
        </ModalDialog>
    );
};

export const AlertDialog = withNoScroll(Dialog);
